module.exports = __webpack_public_path__ + "img/mob_product_02.8a417d02.png";